import { ISpecificationCategoryResponse } from "@/shared/services/interface/responses/ISpecificationResponse";

/**
 * Helper function to find all parent category IDs including the target category itself
 * @param categories - Array of categories to search in
 * @param targetCategoryId - The ID of the target category
 * @returns Array of category IDs from root to target (inclusive)
 */
export function findAllParentCategoryIds(
  categories: ISpecificationCategoryResponse[],
  targetCategoryId: string
): string[] {
  const findCategoryWithPath = (
    cats: ISpecificationCategoryResponse[],
    targetId: string,
    path: string[] = []
  ): string[] | null => {
    for (const category of cats) {
      const currentPath = [...path, category.id];

      if (category.id === targetId) {
        return currentPath;
      }

      // Check children array for subcategories
      if (category.children && Array.isArray(category.children)) {
        const subCategories = category.children.filter(
          (child) => child.type === "category"
        ) as ISpecificationCategoryResponse[];
        if (subCategories.length > 0) {
          const result = findCategoryWithPath(
            subCategories,
            targetId,
            currentPath
          );
          if (result) {
            return result;
          }
        }
      }
    }
    return null;
  };

  const path = findCategoryWithPath(categories, targetCategoryId);
  return path || [];
}

